module.exports = __webpack_public_path__ + "res/35-img_timer.c4d5cd869e7eef793c5cf3fc4381ac49.png";